(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('portefeuille-contrat', {
            parent: 'entity',
            url: '/portefeuille-contrat?page&sort&search',
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY'],
                authenticate: true,
                pageTitle: 'wamasysApp.portefeuilleContrat.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/portefeuille-contrat/portefeuille-contrats.html',
                    controller: 'PortefeuilleContratController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('portefeuilleContrat');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('portefeuille-contrat-detail', {
            parent: 'entity',
            url: '/portefeuille-contrat/{id}?page&sort&search',
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY'],
                authenticate: true,
                pageTitle: 'wamasysApp.portefeuilleContrat.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/portefeuille-contrat/portefeuille-contrat-detail.html',
                    controller: 'PortefeuilleContratDetailController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
            	pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('portefeuilleContrat');
                    $translatePartialLoader.addPart('contrat');
                    $translatePartialLoader.addPart('etatContrat');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PortefeuilleContrat', function($stateParams, PortefeuilleContrat) {
                    return PortefeuilleContrat.get({id : $stateParams.id});
                }]
            }
        })
        
        
        
        .state('portefeuille-contrat-detail.billing', {
            url: '/billing',
            data: {
                authorities: ['ROLE_DATA_OPERATOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/portefeuille-contrat/billing-portefeuille-dialog.html',
                    controller: 'BillingPortefeuilleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['$stateParams', 'PortefeuilleContrat', function($stateParams, PortefeuilleContrat) {
//                            return PortefeuilleContrat.get({id : $stateParams.id});
                            return {id : $stateParams.id};
                        }]
                    }
                }).result.then(function(result) {                	
                    $state.go('portefeuille-contrat-detail',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('portefeuille-contrat-detail');
                });
            }]
        })
        
        
        .state('portefeuille-contrat.new', {
            parent: 'portefeuille-contrat',
            url: '/new',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/portefeuille-contrat/portefeuille-contrat-dialog.html',
                    controller: 'PortefeuilleContratDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                libelle: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('portefeuille-contrat', null, { reload: true });
                }, function() {
                    $state.go('portefeuille-contrat');
                });
            }]
        })
        .state('portefeuille-contrat.edit', {
            parent: 'portefeuille-contrat',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT','ROLE_DATA_OPERATOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/portefeuille-contrat/portefeuille-contrat-dialog.html',
                    controller: 'PortefeuilleContratDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PortefeuilleContrat', function(PortefeuilleContrat) {
                            return PortefeuilleContrat.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('portefeuille-contrat', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('portefeuille-contrat.delete', {
            parent: 'portefeuille-contrat',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/portefeuille-contrat/portefeuille-contrat-delete-dialog.html',
                    controller: 'PortefeuilleContratDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PortefeuilleContrat', function(PortefeuilleContrat) {
                            return PortefeuilleContrat.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('portefeuille-contrat', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
